// extracted by mini-css-extract-plugin
module.exports = {"image":"CryptoCurrencyLogo__image__ZzTUp"};